import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { SmoothScroll } from "./SmoothScroll";
import { Seo } from "./Seo";
import { IntroGate } from "./IntroGate";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { AgentSelectProvider } from "./AgentSelect";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
      }, 300);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

export const Layout = () => (
  <SmoothScroll>
    <AgentSelectProvider>
    <div className="App">
      <div className="noise-overlay" />
      <IntroGate />
      <Seo />
      <ScrollToTop />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <Toaster position="bottom-right" theme="dark" richColors />
    </div>
    </AgentSelectProvider>
  </SmoothScroll>
);
